<!--
  Created by Caroline on 2019/11/25 0025.
-->
<template>
  <div class="container">
    <div class="container--inner" ref="containerInner" :style="containerCenterStyle">
      
      <img src="https://image-weddinglive.marryou520.com/pc/lottery_ribbon.png" alt="" class="ribbon"/>
      <div class="title">{{lottery ? lottery.title : ''}}</div>
      
      <div class="main">
        <div class="qr--wrapper" :class="lotteryWinners.length ? 'small' : ''">
          <img src="https://image-weddinglive.marryou520.com/pc/lottery_qrcode_board.png" alt="" class="qr--bg"/>
          <img :src="lottery.qrcodeUrl" alt="" class="qr"/>
        </div>
        
        <div class="winners" v-if="lotteryWinners.length">
          <img src="https://image-weddinglive.marryou520.com/pc/lottery_winner_board.png" alt="" class="winners--bg"/>
          <div class="winners--title">恭喜中奖啦！</div>
          
          <div class="winners--wrapper" ref="winnersWrapper">
            <div class="winners--container" ref="winnersContainer">
              <div class="winners--item" v-for="item in lotteryWinners">
                <div class="head">
                  <img :src="item.user.headImgUrl" alt="" class="head--img"/>
                </div>
                <div class="item--ribbon">
                  <img src="https://image-weddinglive.marryou520.com/pc/lottery_winner_ribbon.png" alt="" class="item--ribbon-img"/>
                  <div class="item--ribbon-txt">恭喜中奖！</div>
                </div>
                <div class="item--name">{{item.user.nickname}}</div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
  import BScroll from 'better-scroll'
  import {mapActions, mapState, mapGetters} from 'vuex'
  
  export default {
    name: "lottery",
    data() {
      return {
        scroll: null,
        scrollOptions: {},
      }
    },
    computed: {
      ...mapState(['win', 'activityId', 'modeData', 'lottery', 'lotteryWinners']),
      ...mapGetters(['scale']),
      containerCenterStyle () {
        let style = {
          'transform': 'scale(' + this.scale + ')',
        }
        this.win.screenWScale === 1 ? style['margin'] = 'auto' : style['margin-left'] = this.mainML
        return style
      },
      mainML () {
        let mainML = (1500-this.win.winWidth)/2/this.win.winWidth
        mainML = (-mainML*100).toFixed(2) + "%"
        return mainML
      },
    },
    watch: {
      modeData(val) {
      },
      lottery(val) {
        if(this.lotteryWinners.length){
          this.initBScroll()
        }
      },
      lotteryWinners(val) {
        if(val.length){
          this.initBScroll()
        }
      },
    },
    created() {
    
    },
    mounted() {
      if(this.lotteryWinners.length){
        this.initBScroll()
      }
    },
    methods: {
      initBScroll () {
        this.$nextTick(() => {
          this.scroll = new BScroll(this.$refs.winnersWrapper, this.scrollOptions)
          this.scrollToNew()
        })
      },
      scrollToNew() {
        let winnersOsH = this.$refs.winnersWrapper.offsetHeight
        let winnersCOsH = this.$refs.winnersContainer.offsetHeight
        let scrollTop = winnersOsH - winnersCOsH
        // console.log("winnersOsH", winnersOsH, winnersCOsH, scrollTop);
        scrollTop < 0 && this.scroll.scrollTo(0, scrollTop, 500, 'easing')
      },
  
    }
  }
</script>

<style scoped lang="less">
  @import "../less/common.less";
  @import "../less/lottery.less";

</style>



// WEBPACK FOOTER //
// src/components/lottery.vue